import * as React from 'react'

const SvgDownArrowIcon = (props) => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 14 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.8337 1.5L7.00033 7.33333L1.16699 1.5"
      stroke="url(#paint0_linear_1081_15564)"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1081_15564"
        x1="1.16699"
        y1="1.5"
        x2="7.72431"
        y2="10.8982"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={`${props?.color ? props.color : '#FFFFFF'}`} />
        <stop
          offset="1"
          stopColor={`${props?.color ? props.color : '#FFFFFF'}`}
        />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgDownArrowIcon
